import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Data, Router } from '@angular/router';
import { EventEmitterService } from '../services/event-emitter.service';
import { LeadService } from '../services/lead.service';
import { SnackBarService } from '../services/snack-bar.service';

@Component({
  selector: 'app-deadlead-popup',
  templateUrl: './deadlead-popup.component.html',
  styleUrls: ['./deadlead-popup.component.css'],
})
export class DeadleadPopupComponent implements OnInit {
  lead_status: string[] = [];
  editedForm: FormGroup;
  makeCustomerClick: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: Data,
    private formBuilder: FormBuilder,
    private leadService: LeadService,
    private snackBarService: SnackBarService,
    private eventEmitterService: EventEmitterService,
    private route: Router
  ) {
    this.editedForm = formBuilder.group({
      leadSummay: new FormControl(),
      leadStatus: new FormControl(),
      customerStatus: new FormControl(),
    });
  }

  ngOnInit(): void {}

  onClickSave(id) {
    const obj = {
      customer_status:
        this.editedForm.value.customerStatus === null
          ? this.data.custoMmerData.leadData.data.customer_status
          : this.editedForm.value.customerStatus,
      leads_status:
        this.editedForm.value.leadStatus === null
          ? this.data.custoMmerData.leadData.data.leads_status
          : this.editedForm.value.leadStatus,
      lead_summary: this.editedForm.value.leadSummay,
      id: id,
    };
    this.leadService.leadUpdate(obj).subscribe((data) => {
      this.snackBarService.openSnackBar(data.message, 'success-class');
      this.eventEmitterService.filter('Edit Clicked');
      if (data.data.leads_status == 'make_customer') {
        this.route.navigate(['create-customer']);
      }
    });
  }

  onCLickDelete(id) {
    this.leadService.deleteLeadById(id).subscribe((data) => {
      this.snackBarService.openSnackBar(data.message, 'success-class');
      this.eventEmitterService.filter('Edit Clicked');
    });
  }

  makeCustomerRadio() {
    this.makeCustomerClick = false;
  }
}
